import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { authApi } from "../api";

const OwnerLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await authApi.login(password);
      localStorage.setItem("cac_token", res.data.token);
      onSuccess();
    } catch (err) {
      setError("Incorrect password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen brand-gradient-soft grid place-items-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-[#0E5A72] text-sm font-medium mb-6 hover:opacity-80">
          <ArrowLeft className="h-4 w-4" /> Back to website
        </Link>
        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
          <div className="brand-gradient h-14 w-14 rounded-2xl grid place-items-center text-white mx-auto">
            <Lock className="h-7 w-7" />
          </div>
          <h1 className="font-display font-bold text-2xl text-[#0E2A33] text-center mt-4">Owner Dashboard</h1>
          <p className="text-slate-500 text-sm text-center mt-1">Enter your password to manage leads.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="pw">Password</Label>
              <Input id="pw" type="password" autoFocus value={password}
                onChange={(e) => setPassword(e.target.value)} className="mt-1" placeholder="••••" />
            </div>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <Button type="submit" disabled={loading}
              className="w-full bg-[#2E9E6A] hover:bg-[#23875A] text-white rounded-full h-12">
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default OwnerLogin;
